export default "__VITE_ASSET__CEi9xd21__"